import {Component, HostBinding} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {sideMenuItems} from './side-menu-items';
import {MenuItem} from '../../../shared/models/menu-item';
import {
  checkForPermissionWithExceptions,
  checkForPermissionWithFacility
} from '../../../shared/permission/check-permission';
import {TokenService} from '../../../shared/services/token.service';
import {LayoutService} from '../layout.service';
import {Subscription} from 'rxjs';
import {RouteUrls} from '../../../shared/constants/RouteUrls';
import {RequestMethod, RestService} from '../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';
import {ConfirmModalComponent} from '../../shared/modules/confirm-modal/confirm-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {ResponseSnackbarService} from '../../../shared/services/response-snackbar.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent {
  menuItems: MenuItem[] = [];
  private currentUrl: string;
  private layoutSubscription: Subscription;
  @HostBinding('class.closed') private closed = false;
  @HostBinding('class.w-data') private hasItems = true;

  showRequestTab: boolean;
  constructor(
    private restService: RestService,
    private router: Router,
    private dialog: MatDialog,
    private responseSnackBar: ResponseSnackbarService,
    private layoutService: LayoutService,
    private tokenService: TokenService
  ) {
    this.setItems(router.url);
    this.currentUrl = router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        this.setItems(event.urlAfterRedirects);
      }
    });
  }

  public setItems(url: string) {
    if (this.layoutSubscription) {
      this.layoutSubscription.unsubscribe();
      this.layoutSubscription = null;
    }
    this.layoutService.getItemMapper().subscribe(func => {
      this.menuItems = [];
      Object.keys(sideMenuItems).forEach(value => {
        if (url.startsWith(value)) {
          const sideMenuItemList = sideMenuItems[value].filter(it => checkForPermissionWithExceptions(it.permissionLink, this.tokenService.getRolesFromToken(), it.exceptions));
          this.menuItems = func(JSON.parse(JSON.stringify(sideMenuItemList)));
          this.menuItems = this.menuItems.filter(it => it.filterWithFacility ? checkForPermissionWithFacility(it.permissionLink, it.facilityId) : true);
        }
        this.showRequestTab = true;
        // if (url.startsWith('/facility/update')) {
        //   this.menuItems.forEach(item => {
        //     this.showRequestTab = item.showRequestTab === 'APPLICATION_APPROVED';
        //   });
        // }
      });
      this.menuItems = func(JSON.parse(JSON.stringify(this.menuItems)));
      this.hasItems = this.menuItems.length > 0;
    });
  }

  public toggleSideMenu() {
    this.closed = !this.closed;
  }

  public isActive(url: string) {
    const segments = url.split(':pathVariable/');
    let pattern = '';
    for (const segment of segments) {
      pattern = `${pattern}(.*?)${segment}`;
    }
    const reg = new RegExp(pattern);
    return this.currentUrl.match(reg);
  }

  navigateSideMenu(element: any, url: string){
    if (url.includes(RouteUrls.APPLICATION.APPLY_RESET)){
      this.restService.request<any>(RequestMethod.GET, ApiEndpoints.ACCR.APPLICATION,
        Actions.BASE_ACTIONS.READ + `/number_of_unfinished_apps`).subscribe(
        response => {
          if (response.success && !response.data) {
              this.showUnlimitedRequestDialog();
              return;
          }
          else{
            this.router.navigateByUrl(url);
          }
        }
      );
    }else{
      this.router.navigateByUrl(url);
    }
  }

  showUnlimitedRequestDialog() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        fullName: 'Approval Required',
        name: '',
        type: 'Yes',
        removeQuestionMark: true,
        body: 'Request Limit Removal',
        content: 'You have reached the limit of new applications!'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.delete) {
        const data = {
        };
        this.restService.request<any>(
          RequestMethod.POST,
          ApiEndpoints.ACCR.APPLICATION,
          Actions.ACCR_APPLICATION.CREATE_REQUEST,
          {body: data}
        ).subscribe(
          response => {
            this.responseSnackBar.onResponse(response);
          });
      }
    });
  }
}
